// ----------------------------------------------------------------------

const account = {
  displayName: 'Admin',
  email: 'admin@test.com',
  photoURL: '/static/mock-images/avatars/avatar_default.jpg'
};

export default account;
